'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import DocumentGroup from '@/creditflowresearch/domain/DocumentGroup';
import { getContainer } from '@framework/di/getContainer';

const useDocumentGroupData = ({ researchDocumentGroupList, initialGroup, emptyGroupIds }) => {
  const container = getContainer();
  const documentGroupService = container.get(DocumentGroup);
  const [documentGroup, setDocumentGroup] = useState(initialGroup);
  const [collection] = useState([documentGroupService.getDefault(), ...researchDocumentGroupList]);
  const [emptyDocumentGroupIds, setEmptyDocumentGroupIds] = useState(emptyGroupIds);

  useEffect(() => {
    setEmptyDocumentGroupIds(emptyGroupIds);
  }, [initialGroup, emptyGroupIds.join('')]);

  return {
    collection,
    emptyGroupIds: emptyDocumentGroupIds,
    documentGroup,
    setDocumentGroup,
    setEmptyDocumentGroupIds,
  };
};

type DocumentGroupContextType = ReturnType<typeof useDocumentGroupData>;

const DocumentGroupContext = createContext<DocumentGroupContextType>(null);

export const useDocumentGroupContext = () => {
  const context = useContext(DocumentGroupContext);
  if (!context) {
    throw new Error('useDocumentGroupContext must be used within the DocumentGroupContext');
  }
  return context;
};

const DocumentGroupContextProvider = ({ children, initial }) => (
  <DocumentGroupContext.Provider value={ useDocumentGroupData(initial) }>
    { children }
  </DocumentGroupContext.Provider>
);

export default DocumentGroupContextProvider;
